import { isMobile } from 'shared/responsive-helpers'

import useCountryState from 'shared/hooks/useCountryState'
import { guestUserVehicleSelector } from 'manage-guest-user-booking/selectors'

import featureToggles from 'shared/featureToggles'
import Textfield from '@components/Textfield'
import { CardSection } from '@components/CardSection'
import Button from '@components/Button'
import VehicleForm from '@components/VehicleForm'
import MobileViewContainer from './MobileViewContainer'

import styles from './styles.module.scss'

const INITIAL_STATE = {
    tag: '',
    make: '',
    model: '',
    color: '',
}

const VehicleFormSection = ({ onNext, setVehicle, selectVehicle, guestUserVehicle }) => {
    const initializeVehicleFormData = {
        tag: guestUserVehicle?.tag || INITIAL_STATE.tag,
        make: guestUserVehicle?.make || INITIAL_STATE.make,
        model: guestUserVehicle?.model || INITIAL_STATE.model,
        color: guestUserVehicle?.color || INITIAL_STATE.color,
    }

    const [vehicleFormData, setVehicleFormData] = React.useState(initializeVehicleFormData)
    const [isSubmitButtonDisabled, setIsSubmitButtonDisabled] = React.useState(true)
    const { countryStateComponent, setSelectedState, setSelectedCountry, selectedCountry, selectedState } =
        useCountryState()

    const onNextStep = () => {
        onNext()
        setVehicle([{ ...vehicleFormData, displayValue: vehicleFormData.tag }])
        selectVehicle(vehicleFormData)
        // sendGTAGEvent('select_vehicle', {})
    }

    React.useEffect(() => {
        if (featureToggles.caPurchaseFlow) {
            if (guestUserVehicle?.state) {
                setSelectedState(guestUserVehicle?.state)
            }
            if (guestUserVehicle?.country) {
                setSelectedCountry(guestUserVehicle.country)
            }
        }
    }, [])

    React.useEffect(() => {
        if (featureToggles.caPurchaseFlow) {
            if (selectedCountry) {
                setVehicleFormData({ ...vehicleFormData, country: selectedCountry })
            }
            if (selectedState) {
                setVehicleFormData({ ...vehicleFormData, state: selectedState })
            }
        }
    }, [])

    React.useEffect(() => {
        const incorrectFieldsAmount = featureToggles.caPurchaseFlow
            ? Object.keys(vehicleFormData).length < 6
            : Object.keys(vehicleFormData).length < 4

        {
            const hasEmptyRequiredFields =
                incorrectFieldsAmount ||
                Object.values(vehicleFormData).some(value => value === null || value.length === 0)

            setIsSubmitButtonDisabled(hasEmptyRequiredFields)
        }
    }, [vehicleFormData])

    React.useEffect(() => {
        if (selectedState && featureToggles.caPurchaseFlow) {
            setVehicleFormData({ ...vehicleFormData, state: selectedState })
        }
    }, [selectedState])

    React.useEffect(() => {
        if (selectedCountry && featureToggles.caPurchaseFlow) {
            setVehicleFormData({ ...vehicleFormData, country: selectedCountry })
        }
    }, [selectedCountry])

    const cardSectionContent = (
        <>
            <h3 className="font-weight-bold mb-4">
                <T>booking.purchase.vehicle.label</T>
            </h3>
            <div className={styles.vehicleForm}>
                <VehicleForm
                    formValues={vehicleFormData}
                    setFormValues={setVehicleFormData}
                    countryStateComponent={countryStateComponent}
                />
            </div>
        </>
    )

    const buttonsSectionContent = block => (
        <Button onClick={onNextStep} block={block} disabled={isSubmitButtonDisabled}>
            <T>guest.booking.checkout.next.btn.label</T>
        </Button>
    )

    return isMobile() ? (
        <MobileViewContainer
            cardSectionContent={cardSectionContent}
            buttonsSectionContent={buttonsSectionContent(true)}
            className={styles.mobileViewContainer}
        />
    ) : (
        <CardSection className={styles.vehicleFormCardSection}>
            <div className={styles.vehicleFormContainer}>
                <h3 className="font-weight-bold mb-4">
                    <T>booking.purchase.vehicle.label</T>
                </h3>
                <div className={styles.vehicleForm}>
                    <VehicleForm
                        formValues={vehicleFormData}
                        setFormValues={setVehicleFormData}
                        countryStateComponent={countryStateComponent}
                    />
                </div>
                <div className={styles.vehicleNextButton}>{buttonsSectionContent(false)}</div>
            </div>
        </CardSection>
    )
}

export default compose(
    connect(
        createStructuredSelector({
            guestUserVehicle: guestUserVehicleSelector,
        })
    )
)(VehicleFormSection)
